module.exports = __WEBPACK_EXTERNAL_MODULE_71__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/media/Sound","root":["openfl","media","Sound"],"commonjs":"openfl/media/Sound","commonjs2":"openfl/media/Sound"}
// module id = 71
// module chunks = 0